// extracted by mini-css-extract-plugin
export var root = "video-player-popover-module--root--B7n-v";
export var video = "video-player-popover-module--video--7pQEW";